import { PRODUCTS, CATEGORIES } from "@/lib/load/products";

export const ProductSelect = ({ value, onChange, className = "text-input load-select", testId }) => (
  <select className={className} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
    {CATEGORIES.map((cat) => (
      <optgroup key={cat} label={cat}>
        {PRODUCTS.filter((p) => p.cat === cat).map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </optgroup>
    ))}
  </select>
);
